<template>
  <game-template :success="isValid">
    <template v-if="isValid" v-slot:head>
      <p class="title">
        Félicitations ! Vous avez bien déclenché les paiements.
      </p>
      <button class="button" @click="next">Continuer</button>
    </template>
    <template v-else v-slot:head>
      <p class="title">Saisissez les nombres d’heures à payer</p>
      <p class="sub-title">Vous trouverez l'information sur l'interface GTA.</p>
    </template>
    <template v-slot:content>
      <gap-fill-game-template :show-next-button="false" v-on:validate="validate" :button-enabled="canValidate" :show-error="hasValidate && touched.length === 0" :is-valid="isValid">
        <template v-slot:head>
          <zoomable-image>
            <img src="../assets/gap-fill-heure.jpg">
          </zoomable-image>
        </template>
        <template v-slot:content>
          <p><strong>Vous avez convenu avec Eric et Kevin du paiement complet de leurs heures.</strong></p>
          <p>
            <span>Vous saisissez</span>
            <gap-filler-input v-model="gaps.gap1.fill" :good-answer="gaps.gap1.goodAnswer" :show-answers="hasValidate && !isTouched('gap1')" @touched="toggleTouched('gap1')"></gap-filler-input>
            <span>h pour Eric et</span>
            <gap-filler-input v-model="gaps.gap2.fill" :good-answer="gaps.gap2.goodAnswer" :show-answers="hasValidate && !isTouched('gap2')" @touched="toggleTouched('gap2')"></gap-filler-input>
            <span>h pour Kevin.</span>
          </p>
          <p>
            <strong>Anne-Sophie conservera la moitié de ses heures en récupération et Aline 1,5 h</strong>
          </p>
          <p>
            <span>Vous saisissez</span>
            <gap-filler-input v-model="gaps.gap3.fill" :good-answer="gaps.gap3.goodAnswer" :show-answers="hasValidate && !isTouched('gap3')" @touched="toggleTouched('gap3')"></gap-filler-input>
            <span>h pour Anne-Sophie et</span>
            <gap-filler-input v-model="gaps.gap4.fill" :good-answer="gaps.gap4.goodAnswer" :show-answers="hasValidate && !isTouched('gap4')" @touched="toggleTouched('gap4')"></gap-filler-input>
            <span>h pour Aline.</span>
          </p>
          <p>
            <strong>Jean-Baptiste, Agnès et Sylvain conservent l’ensemble de leurs heures, vous n’avez rien à saisir.</strong>
          </p>
        </template>
      </gap-fill-game-template>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import GapFillGameTemplate from '@shared/components/GapFillGameTemplate'
import GapFillerInput from '@shared/components/GapFillerInput'
import gapFillMixin from '@shared/mixins/gapFillMixin'

export default {
  name: 'GapFillHeures',
  mixins: [stepMixin, gapFillMixin],
  components: {
    GapFillGameTemplate,
    GapFillerInput
  },
  data () {
    return {
      gaps: {
        gap1: {
          fill: '',
          goodAnswer: 3
        },
        gap2: {
          fill: '',
          goodAnswer: 4
        },
        gap3: {
          fill: '',
          goodAnswer: 1
        },
        gap4: {
          fill: '',
          goodAnswer: 2.5
        }
      }
    }
  },
  computed: {
    isValid () {
      return Object.keys(this.gaps).filter(gap => Number(this.gaps[gap].fill.replace(',', '.')) !== this.gaps[gap].goodAnswer).length === 0 && !this.canValidate
    }
  },
  methods: {
    validate () {
      this.touched = []
      this.hasValidate = true
      if (this.isValid) {
        window.scrollTo(0, 0)
        this.$store.commit('setGameFinished', true)
      }
    }
  }
}
</script>
